// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.separator {
  height: 15px;
}

.modal-content {
  padding: 15px;
}
.modal-content .div-see {
  overflow-y: auto;
}
.modal-content .div-see .card {
  width: 100%;
  margin: 10px auto;
}
.modal-content .div-see .card .id {
  color: rgb(173, 173, 173);
  font-style: italic;
}
.modal-content .non_inherited {
  color: #8BB7F0;
}
.modal-content .header-info::ng-deep {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
@media screen and (max-width: 1600px) {
  .modal-content .header-info::ng-deep {
    display: flex;
    flex-direction: column;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/+home/+my-libraries/+sites/document-library/shared/dialog-see-file-permissions/dialog-see-file-permissions.component.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;AACF;;AAEA;EACE,aAAA;AACF;AACE;EACE,gBAAA;AACJ;AACI;EACE,WAAA;EACA,iBAAA;AACN;AACM;EACE,yBAAA;EACA,kBAAA;AACR;AAIE;EACE,cAAA;AAFJ;AAIE;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AAFN;AAKE;EACE;IACI,aAAA;IACA,sBAAA;EAHN;AACF","sourcesContent":[".separator {\r\n  height: 15px;\r\n}\r\n\r\n.modal-content {\r\n  padding: 15px;\r\n\r\n  .div-see {\r\n    overflow-y: auto;\r\n\r\n    .card {\r\n      width: 100%;\r\n      margin: 10px auto;\r\n\r\n      .id {\r\n        color: rgb(173, 173, 173);\r\n        font-style: italic;\r\n      }\r\n    }\r\n  }\r\n\r\n  .non_inherited {\r\n    color: #8BB7F0;\r\n  }\r\n  .header-info::ng-deep{\r\n      display:flex;\r\n      flex-direction: row;\r\n      justify-content: space-between ;\r\n      align-items: center;\r\n  }\r\n\r\n  @media screen and (max-width: 1600px) {\r\n    .header-info::ng-deep{\r\n        display:flex;\r\n        flex-direction: column;\r\n    }\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
